export default __webpack_public_path__ + "static/media/snapchat_icon_display.4dc6cde7.png";